import { createSlice } from '@reduxjs/toolkit';

import interventionInitialState from './initialState';
import reducers from './reducers';

const interventionSlice = createSlice({
  name: '@intervention',
  initialState: interventionInitialState,
  reducers,
});

export const interventionActions = interventionSlice.actions;
export const interventionReducers = interventionSlice.reducer;
